export { default } from "./StateActivityStatistics";
